import { Divider, Grid, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMain from 'hooks/useMain';
import moment from 'moment';
import { useState } from 'react';
import CusListLabelField from './CusListLabelField';

const CusAuditCard = ({ title, subTitle, subRightTtile, fields, auditData }) => {
  const { t } = useMain();
  const theme = useTheme();

  return (
    <>
      <Stack p={3} spacing={2}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" width="100%">
            <Typography variant="body1">{title}</Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
              <Typography variant="h4" sx={{ color: theme.palette.primary[400] }}>
                {subTitle}
              </Typography>
              <Typography variant="body1">{subRightTtile}</Typography>
            </Stack>
          </Stack>
        </Stack>
        {_.isEmpty(auditData) && (
          <Typography variant="h4" px={2}>
            {' '}
            {t('NO_RECORDS')}
          </Typography>
        )}

        {_.map(auditData, (currData, index) => {
          //
          return (
            <Stack spacing={2} key={`auditCard-container-${index}`}>
              <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Divider sx={{ borderWidth: 2, height: '20px', borderColor: '#85b9ab' }} />
                  <Typography fontWeight="bold">{moment(currData?.UpdatedDate).format('YYYY/MM/DD HH:mm')}</Typography>
                </Stack>
                <Typography fontWeight="bold">{currData?.UpdatedName}</Typography>
              </Stack>
              {/* <Grid container 
                // key={`${currData?.Id}-auditCard-label-container`} 
                spacing={2}>
                {
                 _.map(fields, (currValue) =>{
                    //  
                    let fieldValue = currData[currValue?.id]
                    if(_.isEqual(currValue?.type, 'checkbox')) {
                        fieldValue = _.isEqual(fieldValue, 0) ? 'N' : 'Y'
                    }
                    //  
                return (
                    <Grid item xs={4} key={`${currValue?.id}-auditCard-labelField`}>
                    <Typography variant="body1" mb={1} sx={{ color: '#bfbfbf' }}>
                        {t(currValue?.label)}
                    </Typography>
                    <Typography variant="body1" >
                    {fieldValue ?? '_'}
                    </Typography>
                    </Grid>
                )
                })                   
                }
            </Grid> */}
              <CusListLabelField
                fields={fields}
                data={currData}
                fieldKey={'id'}
                xs={6}
                sm={6}
                md={6}
                labelFieldKeyPrefix={'auditCard-labelField'}
                justifyContent="space-between"
              />
              <Stack>
                <Divider sx={{ borderWidth: 1 }} variant="fullWidth" />
              </Stack>
            </Stack>
          );
        })}
      </Stack>
    </>
  );
};

export default CusAuditCard;
